'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

// Landing page navigation for non-authenticated users
export function AihumanitNavigation() {

    return (
        <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <Link href="/" className="flex items-center space-x-3">
                        <Image
                            src="/aihumanit_logo.png"
                            alt="AI Humanit logo"
                            width={48}
                            height={48}
                            className="w-12 h-12 rounded-2xl"
                            priority
                        />
                        <span className="font-bold text-2xl">
                            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Human</span>
                            <span className="text-gray-800">it</span>
                        </span>
                    </Link>

                    {/* Public Navigation Links */}
                    <div className="flex items-center space-x-6">
                        {/* Navigation Tabs */}
                        <nav className="hidden md:flex items-center space-x-8">
                            <Button
                                variant="outline"
                                className="border-gray-300 text-gray-700 hover:bg-gray-100 hover:border-gray-400 px-6 py-2.5 rounded-lg font-semibold"
                                asChild
                            >
                                <Link href="/login">Login</Link>
                            </Button>
                            <Button
                                className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2.5 rounded-lg font-semibold hover:from-purple-600 hover:to-pink-600 transition-all duration-200"
                                asChild
                            >
                                <Link href="/signup">Get Started</Link>
                            </Button>
                        </nav>

                        {/* Mobile menu button */}
                        <div className="md:hidden">
                            <Button
                                variant="outline"
                                className="border-gray-300 text-gray-700 hover:bg-gray-100 hover:border-gray-400 px-4 py-2 rounded-lg font-semibold"
                                asChild
                            >
                                <Link href="/login">Login</Link>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}
